import React from "react";
import { Container, Box } from "@mui/material";
import Slider from '../../components/Slider/animatedSlider';
import DadosSite from '../../components/DadosSiteHome/DadosHome';
import Noticias from '../../components/NoticiasComponents/Noticias';
import { FaleConosco } from '../../components/ContatoComponents/FaleConosco';
 

function Home() {
  return (
    <Box sx={{ width: '100%', overflowX: 'hidden', padding: 0 }}>
      <Container maxWidth="xl" sx={{ padding: 0 }}>
        <Slider />
        <DadosSite />
        <Noticias />
        <FaleConosco />
      </Container>
    </Box>
  );
}

export default Home;
